import { Badge, Typography } from '@material-ui/core'
import { useSelector } from 'react-redux'

import { selectInviters } from 'store/inviters'

import Avatar from '../components/Avatar'

const NotificationAvatar = () => {
  const inviters = useSelector(selectInviters)
  const badgeCount = inviters.length
  return (
    <Badge
      badgeContent={badgeCount}
      color="error"
      invisible={badgeCount === 0}
      overlap="circular"
    >
      <Avatar />
      <Typography variant="srOnly">{`${badgeCount} Notification(s)`}</Typography>
    </Badge>
  )
}

export default NotificationAvatar
